import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APP_CONSTANT } from 'src/app/core/_constants/app.constant';
import { RouteConstant } from 'src/app/core/_constants/route.constant';

@Component({
  selector: 'app-password-updated',
  templateUrl: './password-updated.component.html',
  styleUrls: ['./password-updated.component.scss']
})
export class PasswordUpdatedComponent implements OnInit {
  message = APP_CONSTANT.PASSWORDUPDATE
  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  loginPage() {
    this.router.navigate([`${RouteConstant.Login}`])
  }
}
